(function () {
  'use strict';

  if (window.__faqInitialized) return;
  window.__faqInitialized = true;

  var SYNONYMS = {
    en: {
      'tremolo': ['bridge', 'vibrato', 'whammy', 'trem'],
      'bridge': ['tremolo', 'vibrato'],
      'neck swap': ['neck change', 'quick change', 'interchange'],
      'pickup swap': ['pickup module', 'pickup change'],
      'modular': ['swap', 'interchangeable', 'system'],
      'headless': ['hammerhead', 'no headstock'],
      'price': ['cost', 'how much', 'pricing', 'expensive', 'afford'],
      'ship': ['shipping', 'delivery', 'deliver', 'send'],
      'warranty': ['guarantee', 'coverage', 'defect', 'repair'],
      'left hand': ['lefty', 'left-handed', 'southpaw'],
      'fret': ['frets', 'adjustable fret', 'fret system'],
      'fx': ['effects', 'fx card', 'pedal', 'fx cards'],
      'weight': ['heavy', 'light', 'how much does it weigh'],
      'color': ['colour', 'anodize', 'anodized', 'finish'],
      'case': ['bag', 'backpack', 'gig bag', 'carry'],
      'custom': ['customize', 'customise', 'designer', 'build your own'],
      'wood': ['tonewood', 'maple', 'mahogany', 'ebony', 'rosewood', 'alder'],
      'gimmick': ['toy', 'serious', 'real guitar', 'lego'],
      'bolt': ['bolt-on', 'bolt on', 'neck joint'],
      'battery': ['power', '9v', 'charge', 'rechargeable'],
      'string': ['restring', 'stringing', 'string change']
    },
    tr: {
      'köprü': ['tremolo', 'vibrato', 'whammy', 'bridge'],
      'tremolo': ['köprü', 'vibrato', 'bridge'],
      'sap değişim': ['sap değiştirme', 'hızlı değişim', 'quick change'],
      'manyetik değişim': ['pickup modülü', 'manyetik değiştirme'],
      'modüler': ['değiştirilebilir', 'sistem', 'modular'],
      'headless': ['hammerhead', 'sapsız', 'kafa yok'],
      'fiyat': ['maliyet', 'ücret', 'ne kadar', 'pahalı', 'kaç para', 'price', 'cost'],
      'kargo': ['teslimat', 'gönderim', 'shipping', 'delivery'],
      'garanti': ['güvence', 'kapsam', 'tamir', 'onarım', 'warranty'],
      'solak': ['sol el', 'left-handed', 'lefty'],
      'perde': ['perdeler', 'ayarlanabilir perde', 'perde sistemi', 'fret'],
      'efekt': ['fx', 'fx kart', 'pedal', 'effects'],
      'fx': ['efekt', 'fx kart', 'pedal'],
      'ağırlık': ['kilo', 'ağır', 'hafif', 'ne kadar ağır', 'weight'],
      'renk': ['anodize', 'anodized', 'kaplama', 'finish', 'color'],
      'çanta': ['kılıf', 'sırt çantası', 'gig bag', 'backpack', 'case'],
      'özel': ['özelleştir', 'kişiselleştir', 'tasarımcı', 'kendin yap', 'custom'],
      'tasarım': ['designer', 'tasarımcı', 'özelleştir'],
      'ahşap': ['tonewood', 'maple', 'mahogany', 'ebony', 'rosewood', 'alder', 'akçaağaç', 'maun'],
      'pil': ['batarya', 'güç', '9v', 'şarj', 'battery'],
      'tel': ['string', 'akort', 'telleme'],
      'sap': ['neck', 'klavye'],
      'gövde': ['body', 'body type', 'gövde tipi']
    }
  };

  var I18N_KEYS = {
    resultOne:  'data-js-result-one',
    resultMany: 'data-js-result-many',
    resultNone: 'data-js-result-none',
    countOne:   'data-js-count-one',
    countMany:  'data-js-count-many'
  };

  var root = document.querySelector('.faq-page');
  if (!root) return;

  var faqItems = document.querySelectorAll('.faq-item');
  if (!faqItems.length) return;

  var lang = (document.documentElement.lang || 'en').toLowerCase();
  var synonyms = SYNONYMS[lang] || SYNONYMS.en;

  var i18n = readI18nFromDom(root);
  var faqData = buildFaqIndex(faqItems, synonyms);

  var refs = {
    input: document.getElementById('faqSearch'),
    clear: document.getElementById('searchClear'),
    icon: document.getElementById('searchIcon'),
    meta: document.getElementById('searchMeta'),
    mostAsked: document.getElementById('mostAsked'),
    noResults: document.getElementById('noResults'),
    tabs: document.querySelectorAll('.cat-tab'),
    categories: document.querySelectorAll('.faq-category'),
    items: faqItems
  };

  var activeCat = 'all';
  var fuse = initFuse(faqData);

  wireAccordion();
  wireCategoryTabs();
  wireSearch();
  wireMostAskedCards();
  wireEscape();
  updateCounts();

  // --- helpers ---

  function readI18nFromDom(el) {
    return {
      resultOne:  el.getAttribute(I18N_KEYS.resultOne)  || '{n} result for "{q}"',
      resultMany: el.getAttribute(I18N_KEYS.resultMany) || '{n} results for "{q}"',
      resultNone: el.getAttribute(I18N_KEYS.resultNone) || 'No results for "{q}"',
      countOne:   el.getAttribute(I18N_KEYS.countOne)   || 'question',
      countMany:  el.getAttribute(I18N_KEYS.countMany)  || 'questions'
    };
  }

  function translateTpl(tpl, vars) {
    var out = (typeof window.getTranslation === 'function') ? window.getTranslation(tpl) : tpl;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        out = out.split('{' + k + '}').join(vars[k]);
      });
    }
    return out;
  }

  function buildFaqIndex(items, syn) {
    var data = [];
    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      var answer = item.querySelector('.faq-answer');
      var q = summary.textContent.trim();
      var a = answer ? answer.textContent.trim() : '';
      var combined = (q + ' ' + a).toLowerCase();
      var kw = [];
      Object.keys(syn).forEach(function (k) {
        if (combined.indexOf(k) !== -1) kw = kw.concat(syn[k]);
      });
      data.push({
        id: item.id,
        question: q,
        answer: a,
        keywords: kw.join(' ')
      });
    });
    return data;
  }

  function initFuse(data) {
    if (typeof Fuse === 'undefined') return null;
    return new Fuse(data, {
      keys: [
        { name: 'question', weight: 2.5 },
        { name: 'keywords', weight: 1.5 },
        { name: 'answer',   weight: 1 }
      ],
      threshold: 0.35,
      includeMatches: true,
      includeScore: true,
      minMatchCharLength: 2,
      ignoreLocation: true
    });
  }

  function resetItemStates() {
    refs.items.forEach(function (i) {
      i.classList.remove('filter-hidden', 'search-match');
    });
  }

  function applyActiveCategoryVisibility() {
    refs.categories.forEach(function (c) {
      c.classList.toggle('hidden', activeCat !== 'all' && c.getAttribute('data-cat') !== activeCat);
    });
  }

  function wireAccordion() {
    document.addEventListener('toggle', function (e) {
      var t = e.target;
      if (t.tagName === 'DETAILS' && t.open && t.classList.contains('faq-item')) {
        var grid = t.closest('.faq-grid');
        if (grid) {
          grid.querySelectorAll('.faq-item[open]').forEach(function (d) {
            if (d !== t) d.open = false;
          });
        }
      }
    }, true);
  }

  function updateCounts() {
    refs.categories.forEach(function (cat) {
      var n = cat.querySelectorAll('.faq-item:not(.filter-hidden)').length;
      var el = cat.querySelector('.cat-count');
      if (!el) return;
      var suffix = n === 1 ? i18n.countOne : i18n.countMany;
      var translated = (typeof window.getTranslation === 'function') ? window.getTranslation(suffix) : suffix;
      el.textContent = n + ' ' + translated;
    });
  }

  function wireCategoryTabs() {
    refs.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (refs.input && refs.input.value.trim()) {
          refs.input.value = '';
          clearSearch();
        }
        activeCat = tab.getAttribute('data-cat');
        refs.tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        applyActiveCategoryVisibility();
        resetItemStates();
        if (refs.noResults) refs.noResults.style.display = 'none';
        if (refs.mostAsked) refs.mostAsked.style.display = '';
        if (refs.meta) refs.meta.textContent = '';
        updateCounts();
      });
    });
  }

  function wireSearch() {
    if (!refs.input) return;
    var debounce;
    refs.input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = refs.input.value.trim();
      if (!q) { clearSearch(); return; }
      if (refs.clear) refs.clear.style.display = 'block';
      if (refs.icon)  refs.icon.style.display  = 'none';
      debounce = setTimeout(function () { doSearch(q); }, 150);
    });

    if (refs.clear) {
      refs.clear.addEventListener('click', function () {
        refs.input.value = '';
        clearSearch();
        refs.input.focus();
      });
    }
  }

  function clearSearch() {
    if (refs.clear) refs.clear.style.display = 'none';
    if (refs.icon)  refs.icon.style.display  = '';
    if (refs.meta)  refs.meta.textContent    = '';
    if (refs.mostAsked) refs.mostAsked.style.display = '';
    if (refs.noResults) refs.noResults.style.display = 'none';
    resetItemStates();
    applyActiveCategoryVisibility();
    updateCounts();
  }

  function doSearch(q) {
    if (!fuse) return;
    var res = fuse.search(q);
    var ids = res.map(function (r) { return r.item.id; });
    if (refs.mostAsked) refs.mostAsked.style.display = 'none';
    refs.categories.forEach(function (c) { c.classList.remove('hidden'); });
    refs.items.forEach(function (i) {
      if (ids.indexOf(i.id) !== -1) {
        i.classList.remove('filter-hidden');
        i.classList.add('search-match');
      } else {
        i.classList.add('filter-hidden');
        i.classList.remove('search-match');
      }
    });
    refs.categories.forEach(function (c) {
      if (!c.querySelectorAll('.faq-item:not(.filter-hidden)').length) c.classList.add('hidden');
    });
    if (refs.meta) {
      var tpl = res.length === 0
        ? i18n.resultNone
        : (res.length === 1 ? i18n.resultOne : i18n.resultMany);
      refs.meta.textContent = translateTpl(tpl, { n: res.length, q: q });
    }
    if (refs.noResults) refs.noResults.style.display = res.length ? 'none' : 'block';
    updateCounts();
  }

  function wireMostAskedCards() {
    document.querySelectorAll('.ma-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById(card.getAttribute('data-target'));
        if (!t) return;
        activeCat = 'all';
        refs.tabs.forEach(function (b) { b.classList.remove('active'); });
        if (refs.tabs[0]) refs.tabs[0].classList.add('active');
        refs.categories.forEach(function (c) { c.classList.remove('hidden'); });
        resetItemStates();
        t.open = true;
        setTimeout(function () {
          t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 50);
        t.style.borderColor = '#9e8365';
        t.style.boxShadow   = '0 2px 12px rgba(158, 131, 101, 0.15)';
        setTimeout(function () {
          t.style.borderColor = '';
          t.style.boxShadow   = '';
        }, 2000);
      });
    });
  }

  function wireEscape() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && refs.input && document.activeElement === refs.input) {
        refs.input.value = '';
        clearSearch();
        refs.input.blur();
      }
    });
  }
})();
